// extracted by mini-css-extract-plugin
export default {"footerDetails":"Footer_footerDetails__dx6fk"};